module.exports = __webpack_public_path__ + "media/newstyle/images/icon-trash-can-c0ccd19c5d83d84a3c35d3ac9fe99c11.svg";